"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = _interopRequireDefault(require("underscore"));

var _backbone = _interopRequireDefault(require("backbone"));

var _backboneValidation = _interopRequireDefault(require("backbone-validation"));

var _config = _interopRequireDefault(require("config"));

var _Global = _interopRequireDefault(require("models/Global"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_underscore.default.extend(_backbone.default.Validation.patterns, {
  email2: /^[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
});

var contactOrganizer = _backbone.default.Model.extend({
  url: function url() {
    var url = _config.default.baseUrl + '/events/' + _Global.default.get('event').get('id') + '/contactOrganizer';
    return url;
  },
  validation: {
    sender: [{
      required: true,
      msg: 'Name is required'
    }, {
      maxLength: 60,
      msg: 'Name is too long'
    }],
    body: [{
      required: true,
      msg: 'Message is required'
    }, {
      maxLength: 6000,
      msg: 'Message is too long'
    }],
    from: [{
      required: true,
      msg: 'Email is required'
    }, {
      pattern: 'email2',
      msg: 'Email is not valid'
    }]
  }
});

var _default = contactOrganizer;
exports.default = _default;